import { useQuery } from '@tanstack/react-query';

import { listRooms } from '~/services/AccommodationService';

export const propertyRoomsQueryKeys = {
  all: ['accommodation', 'property-rooms'] as const,
  details: () => [...propertyRoomsQueryKeys.all, 'detail'] as const,
  detail: (propertyId: string) => [...propertyRoomsQueryKeys.details(), propertyId] as const,
};

interface UseGetPropertyRoomsParams {
  propertyId: string;
  enabled?: boolean;
}

export function useGetPropertyRooms({ propertyId, enabled = true }: UseGetPropertyRoomsParams) {
  return useQuery({
    queryKey: propertyRoomsQueryKeys.detail(propertyId),
    queryFn: async ({ signal }) => {
      const response = await listRooms({ propertyId, signal });
      return response.result ?? [];
    },
    enabled: enabled && !!propertyId,
  });
}
